import React from 'react';

const QuizResultListItemComponent = ({info,correct_count,total_count}) => (
    <div className="item">
        <span>{info.name_surname}</span>
        <span className="count">{correct_count} / {total_count}</span>
    </div>
);

export default QuizResultListItemComponent;